import { Box, BoxProps } from '@mui/material';
import { FC } from 'react';
import { SURFACE_BG } from '../constants';

export const PanelPaper: FC<BoxProps> = (props) => {
  return (
    <Box
      {...props}
      sx={{
        bgcolor: SURFACE_BG,
        px: 2,
        py: 1,
        borderRadius: 1,
        ...props.sx,
      }}
    />
  );
};
